/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu8FQfX%7Bgap%3Avar(--ds-space-025%2C2px)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._46hvQm1Y8M%7Bpadding-block-start%3Avar(--ds-space-050%2C4px)%7D%0A._0xmtkoFQfX%7Bpadding-block-end%3Avar(--ds-space-025%2C2px)%7D%0A._2sNsIg7NXe%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D%0A._0bjKvDcjp5%7Bborder-radius%3Avar(--ds-radius-xsmall%2C2px)%7D%0A._3hxITi6wH8%7Bborder-style%3Asolid%7D%0A._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._3vBAKHWkXl%7Bborder-color%3Avar(--ds-border-bold%2C%237d818a)%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._0jFU0VbKFA%7Bheight%3A1.25rem%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._46hvQmFQfX%7Bpadding-block-start%3Avar(--ds-space-025%2C2px)%7D%0A._0LQT5EgVvo%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D%0A._03SyCPgVvo%7Bpadding-inline-end%3Avar(--ds-space-075%2C6px)%7D%0A._2OUyjtZqHV%7Bbox-shadow%3Aunset%7D%0A._2w56ZUZqHV%7B-webkit-box-shadow%3Aunset%7D%0A._0OZTBgZqHV%7B-moz-box-shadow%3Aunset%7D%0A._1UtDYzZqHV%7Bcolor%3Aunset%7D%0A._0GTcwRZqHV%7Bmargin-inline-start%3Aunset%7D%0A._2xTnZxZqHV%7Bmargin-inline-end%3Aunset%7D%0A._43nrzTZqHV%7Bmargin-block-start%3Aunset%7D%0A._0rIjykZqHV%7Bmargin-block-end%3Aunset%7D%0A._4ouGXIZqHV%7Bmin-width%3Aunset%7D%0A._275DnzZqHV%7Btext-shadow%3Aunset%7D%0A._0KLXruS2te%7Bbackground-color%3Aunset%21important%7D");

























const styles = {
  shortcutSegmentsContainer: "_2mHwu8FQfX _3iDTPbQ4SZ _46hvQm1Y8M _0xmtkoFQfX",
  shortcutSegment: "_2sNsIg7NXe _0bjKvDcjp5 _3hxITi6wH8 _2V7sgONvrM _3vBAKHWkXl _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VbKFA _24h04i2Njc _46hvQmFQfX _0xmtkoFQfX _0LQT5EgVvo _03SyCPgVvo _2OUyjtZqHV _2w56ZUZqHV _0OZTBgZqHV _1UtDYzZqHV _0GTcwRZqHV _2xTnZxZqHV _43nrzTZqHV _0rIjykZqHV _4ouGXIZqHV _275DnzZqHV _0KLXruS2te"
};
type TooltipShortcutProps = {
  shortcut: string[];
};

/**
 * __Tooltip shortcut__
 *
 * An internal component that is used to display a keyboard shortcut within a tooltip, showing each key
 * as a styled segment after the main tooltip content.
 */
export const TooltipShortcut = ({
  shortcut
}: TooltipShortcutProps): JSX.Element => {
  return <div className={ax([styles.shortcutSegmentsContainer])}>
			{shortcut.map((segment, index) => <kbd key={`${segment}-${index}`} className={ax([styles.shortcutSegment])}>
					{segment}
				</kbd>)}
		</div>;
};